<template>
    <div class="customermanagement">
        <div class="header">
            <el-row>
                <el-col :span="7">
                    <label class="headerlabel">客户名称</label>
                    <el-input v-model="param.customName" placeholder="请输入客户名称" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="7">
                    <label class="headerlabel">联系方式</label>
                    <el-input v-model="param.customPhone" placeholder="请输入手机号码" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="10">
                    <label class="headerlabel">所在地区</label>
                    <el-select v-model="param.customArea" placeholder="请选择" class="autowidth" clearable >
                        <el-option v-for="item in AreaList" :key="item.dicKey" :label="item.cDicValue" :value="item.cDicValue"></el-option>
                    </el-select>
                    <el-button type="primary" style="margin-left: 20px;" @click="handleinitialization(1)">筛选</el-button>
                    <el-button @click="react">重置条件</el-button>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
                
            </el-row>
        </div>

        <main class="MainContent">
            <el-button type="primary" style="margin: 20px 0;" @click="dialogVisible=true">新增客户</el-button>
            <el-table
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            :data="CustomermanagementData"
            style="width: 100%">
                <el-table-column prop="customCode" label="编号" width="50px"></el-table-column>
                <el-table-column prop="customName" label="客户名称"></el-table-column>
                <el-table-column prop="customArea" label="所在地区"></el-table-column>
                <el-table-column prop="customPhone" label="联系方式"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="edit(scope.row)">修改</el-button>
                        <el-popconfirm title="是否确定删除？" @confirm="confirm(scope.row.customId)">
                            <el-button type="text" style="color: #F24B4E;margin-left: 10px;" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageNum"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

        <el-dialog
            title="新增客户"
            :visible.sync="dialogVisible"
            width="480px"
            center
            :before-close="handleClose">
            <div class="dialogcontent">
                <el-form style="padding: 0 40px;" label-width="80px">
                    <el-form-item label="客户编号">
                        <el-input type="text" v-model="AddParams.customCode" maxlength="30" placeholder="请输入客户编号"  show-word-limit class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="所在地区">
                        <el-select v-model="AddParams.customArea" placeholder="请选择" style="width: 280px;" clearable >
                            <el-option v-for="item in AreaList" :key="item.dicKey" :label="item.cDicValue" :value="item.cDicValue"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系方式">
                        <el-input type="text" v-model="AddParams.customPhone" maxlength="11" placeholder="请输入联系方式"  show-word-limit class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="客户名称">
                        <el-input type="text" v-model="AddParams.customName" maxlength="10" placeholder="请输入客户名称"  show-word-limit class="autowidth" clearable></el-input>
                    </el-form-item>

                </el-form>
                <div style="text-align: right;margin-right: 40px;">
                    <el-button  @click="handleClose">关闭</el-button>
                    <el-button type="primary" @click="Addcovenant()">保存</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:false,
            dialogVisible:false,
            isEdit:false,
            param:{
                pageNum:1,
                pageSize:10,
                PageTotal:0,
                customName:'',
                customCode:'',
                customArea:'',
                customPhone:''
            },
            AddParams:{
                customCode:"",
                customName:"",
                customPhone:"",
                customArea:""
            },
            AreaList:[],
            CustomermanagementData: []
        }
    },
    mounted() {
        this.GetDictionaryList();
        this.init();
    },
    methods: {
        GetDictionaryList(){
            this.$Http_Post('User/GetDictionaryList', { DicTypCode: 24 }).then((res) => {
                if (res.Code == 0) {
                    this.AreaList = res.Data;
                }
            })
        },
        init(){
            this.loading=true
            this.$Http_Post('/kg/custom/list',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.param.PageTotal=res.Counts;
                    this.CustomermanagementData=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        handleinitialization(val){
            this.param.pageNum=val;
            this.init();
        },
        handleClose(){
            this.dialogVisible=false;
        },

        react(){
            this.param=this.$options.data().param;
            this.init();
        },

        Addcovenant(){
            let Url=this.isEdit?'/kg/custom/edit':'/kg/custom/add';
            this.$Http_Post(Url,this.AddParams).then(res=>{
                if(res.Code==0){
                    this.AddParams=this.$options.data().AddParams;
                    this.isEdit=false;
                    this.handleinitialization(1);
                    this.handleClose();
                    this.$message.success(res.Message);
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        // 修改
        edit(e){
            this.AddParams=e;
            this.isEdit=true;
            this.dialogVisible=true;
        },
        // 删除
        confirm(id){
            this.$Http_Post('/kg/custom/remove/'+id).then(res=>{
                if(res.Code==0){
                    this.$message.success(res.Message);
                    this.handleinitialization(1);
                }else{
                    this.$message.error(res.Message);
                }
            });
        }
    },
}
</script>
<style>
.customermanagement .header{background: #fff;padding:20px 20px 0;}
.customermanagement .header .headerlabel{width:90px;display: inline-block;}
.customermanagement .header .autowidth{width: 240px;}
.customermanagement .MainContent{background: #fff;padding:0 16px 20px;margin:16px 0 0;}
</style>